import Cookies from 'js-cookie';

// 存储键常量
export const STORAGE_KEYS = {
    TOKEN: 'ctoken',
    REFRESH_TOKEN: 'crefresh_token',
    TENANT_ID: 'ctenantId',
    LOCALE: 'locale',
};

/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
    // 查看 v2.4.3版本更新日志
    setKey(key) {
        // @ts-ignore
        return `${__NEXT_NAME__}:${key}`;
    },
    // 设置永久缓存
    set(key, val) {
        window.localStorage.setItem(Local.setKey(key), JSON.stringify(val));
    },
    // 获取永久缓存
    get(key) {
        let json = window.localStorage.getItem(Local.setKey(key));
        return JSON.parse(json);
    },
    // 移除永久缓存
    remove(key) {
        window.localStorage.removeItem(Local.setKey(key));
    },
    // 移除全部永久缓存
    clear() {
        window.localStorage.clear();
    },
};

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
    // 设置临时缓存
    set(key, val) {
        if (key === STORAGE_KEYS.TOKEN || key === STORAGE_KEYS.REFRESH_TOKEN || key === STORAGE_KEYS.TENANT_ID) {
            Cookies.set(key, val);
        }
        window.sessionStorage.setItem(key, JSON.stringify(val));
    },
    // 获取临时缓存
    get(key) {
        if (key === STORAGE_KEYS.TOKEN || key === STORAGE_KEYS.REFRESH_TOKEN || key === STORAGE_KEYS.TENANT_ID) return Cookies.get(key);
        let json = window.sessionStorage.getItem(key);
        return JSON.parse(json);
    },
    // 移除临时缓存
    remove(key) {
        if (key === STORAGE_KEYS.TOKEN || key === STORAGE_KEYS.REFRESH_TOKEN || key === STORAGE_KEYS.TENANT_ID) return Cookies.remove(key);
        window.sessionStorage.removeItem(key);
    },
    // 移除全部临时缓存
    clear() {
        Cookies.remove(STORAGE_KEYS.TOKEN);
        Cookies.remove(STORAGE_KEYS.REFRESH_TOKEN);
        Cookies.remove(STORAGE_KEYS.TENANT_ID);
        window.sessionStorage.clear();
    },
    // 获取当前存储的 token
    getToken() {
        return this.get(STORAGE_KEYS.TOKEN);
    },
    // 获取当前的租户
    // auto 模式（VITE_AUTO_TENANT=true）：无值返回 null，由调用方决定如何处理
    // 非 auto 模式：兜底返回 1，保持开发/单租户环境的现有行为
    getTenant() {
        const stored = Local.get(STORAGE_KEYS.TENANT_ID);
        // 只认纯数字：历史脏值（对象/undefined）拼进请求头会让后端解析租户直接 500
        if (stored != null && /^\d+$/.test(String(stored))) return stored;
        return import.meta.env.VITE_AUTO_TENANT === 'true' ? null : 1;
    },
};
